import React from "react";
import profilepic from "../../assests/modalpic.png";
import Loading from "../../components/Loading";
import {
  useTopUsers,
  TopUsersTabs,
  TopUsersTable,
  VerifyProfileModal,
  TopUsersPagination,
  formatDate,
} from "../../components/TopUsers";

export default function TopUsers() {
  const {
    activeTab,
    setTab,
    users,
    searchQuery,
    setSearchQuery,
    isLoading,
    backendPage,
    backendLimit,
    total,
    totalPages,
    currentPage,
    startIndex,
    endIndex,
    handleNext,
    handlePrev,
    verifyModalOpen,
    selectedUserForVerify,
    openVerifyModal,
    closeVerifyModal,
  } = useTopUsers();

  return (
    <div className="p-4 w-full min-w-0 overflow-x-hidden">
      {/* Tabs - same style as Subscription / Users */}
      <TopUsersTabs activeTab={activeTab} onTabChange={setTab} />

      {/* Card - same wrapper as UserProfiles / Subscription */}
      <div className="bg-white rounded-b-xl rounded-t-none sm:rounded-t-xl shadow-md border border-t-0 border-gray-200 overflow-hidden">
        <div className="p-5 sm:p-6 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
            <h2 className="text-md md:text-xl font-bold text-gray-800 tracking-tight">
              Top Users
            </h2>
            <input
              type="text"
              placeholder="Search by name or email..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full sm:w-56 text-sm border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 shadow-sm"
              aria-label="Search by name or email"
            />
          </div>
        </div>

        <div className="p-4 sm:p-6">
          {isLoading ? (
              <div className="text-center py-6">
              <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-red-500 border-t-transparent" />
              <p className="mt-4 text-gray-600 font-medium text-sm">
                Loading top users...
              </p>
            </div>
          ) : (
            <>
              <TopUsersTable
                users={users}
                backendPage={backendPage}
                backendLimit={backendLimit}
                formatDate={formatDate}
                onVerifyUser={openVerifyModal}
              />

              <div className="mt-4 sm:mt-6">
                <TopUsersPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  total={total}
                  startIndex={startIndex}
                  endIndex={endIndex}
                  onPrev={handlePrev}
                  onNext={handleNext}
                />
              </div>
            </>
          )}
        </div>
      </div>

      <VerifyProfileModal
        isOpen={verifyModalOpen}
        onClose={closeVerifyModal}
        user={selectedUserForVerify}
        fallbackImageSrc={profilepic}
      />
    </div>
  );
}
